export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/IE-cf26374304b7e0c39cf7463a00db479a.png";